import { Calendar } from '@src/models/app.types'
import { AllEventsStoreState } from './allEvents.types'

export const reducers = {
  updateCalendarState: (state: AllEventsStoreState, { payload }: { payload: Calendar }) => ({
    ...state,
    calendar: {
      ...state.calendar,
      ...payload,
    },
  }),
}

export default reducers
